import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ExploreTour from "components/Tour/ExploreTour";

import { getIsOpenExplore, getStep, updateIsOpenExplore, updateStep } from "containers/Tour/reducer";
import { updateType } from "containers/View/reducer";
import * as nextReducer from "containers/Next/NextReducer";

class ExploreTourContainer extends React.PureComponent {
  render() {
    return <ExploreTour {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateIsOpenExplore: (isOpen) => dispatch(updateIsOpenExplore(isOpen)),
    updateStep: (step) => dispatch(updateStep(step)),
    updateType: (type) => dispatch(updateType(type)),

    scrollReportByTitle: (val) => {
      dispatch(nextReducer.scrollReportByTitle(undefined, val));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: getIsOpenExplore(state),
    step: getStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ExploreTourContainer);
